<template>
  <div>
    <!-- 본문 -->
    <div class="py-8">
      <v-sheet class="py-4 px-4 mx-auto rounded-lg text-center" width="80%" max-width="400" outlined>
        <!-- 로고 & 문구 -->
        <div class="d-flex mb-2 mx-auto">
          <v-img height="40" width="140" contain src="@/assets/logo/main.svg"></v-img>
        </div>
        <p class="text-subtitle-1 font-weight-medium mt-2 grey--text text--darken-2">{{ $t("page.register.title") }}</p>
        <p class="text-caption grey--text text--darken-1">{{ $t("page.register.agree-need") }}</p>

        <!-- 약관 동의 -->
        <v-sheet width="94%" class="mx-auto">
          <!-- 이용약관 -->
          <v-sheet class="mt-10 d-flex">
            <!-- 체크박스 -->
            <v-checkbox
              style="padding-top: 3px !important"
              class="ma-0 pa-0"
              color="primary"
              v-model="rule"
              :error-messages="rule_Errors"
              :label="$t('bottom.use_terms')"
              required
              @change="$v.rule.$touch()"
              @blur="$v.rule.$touch()"
            ></v-checkbox>
            <v-spacer></v-spacer>

            <!-- 약관보기 -->
            <router-link to="/policy/rule?type=read" style="cursor: pointer; text-decoration: none !important">
              <p class="text-subtitle-2 font-weight-bold mt-3px mr-3 primary--text">
                <span v-if="!$vuetify.breakpoint.mobile">{{ $t("page.register.view-terms") }}</span>
                <v-icon size="20" class="ml-1 mb-2px" color="primary"> mdi-open-in-new </v-icon>
              </p>
            </router-link>
          </v-sheet>

          <!-- 개인정보처리방침 -->
          <v-sheet class="d-flex">
            <!-- 체크박스 -->
            <v-checkbox
              style="padding-top: 3px !important"
              class="ma-0 pa-0"
              color="primary"
              v-model="privacy"
              :error-messages="privacy_Errors"
              :label="$t('bottom.private_terms')"
              required
              @change="$v.privacy.$touch()"
              @blur="$v.privacy.$touch()"
            ></v-checkbox>
            <v-spacer></v-spacer>

            <!-- 약관보기 -->
            <router-link to="/policy/privacy?type=read" style="cursor: pointer; text-decoration: none !important">
              <p class="text-subtitle-2 font-weight-bold mt-3px mr-3 primary--text">
                <span v-if="!$vuetify.breakpoint.mobile">{{ $t("page.register.view-terms") }}</span>
                <v-icon size="20" class="ml-1 mb-2px" color="primary"> mdi-open-in-new </v-icon>
              </p>
            </router-link>
          </v-sheet>

          <!-- 만 14세 이상 확인: 만 14세 미만은 가입할 수 없다(처리방침, 10/19). 이메일·카카오 가입 모두 이 화면을 지난다 -->
          <v-sheet class="d-flex">
            <v-checkbox
              style="padding-top: 3px !important"
              class="ma-0 pa-0"
              color="primary"
              v-model="age"
              :error-messages="age_Errors"
              :label="$t('page.register.age-14')"
              required
              @change="$v.age.$touch()"
              @blur="$v.age.$touch()"
            ></v-checkbox>
          </v-sheet>

          <!-- 버튼 -->
          <v-sheet class="mt-6">
            <v-btn color="primary" width="100%" large dark depressed @click="submit()"> {{ $t("page.register.go-next-btn-title") }} </v-btn>
          </v-sheet>
        </v-sheet>
      </v-sheet>
    </div>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate"
import { mapState } from "vuex"
import { markJoinAgreed } from "@/util/joinAgreement"

export default {
  mixins: [validationMixin],

  validations: {
    rule: {
      checked(val) {
        return val
      },
    },

    privacy: {
      checked(val) {
        return val
      },
    },

    age: {
      checked(val) {
        return val
      },
    },
  },

  data: () => ({
    rule: false,
    privacy: false,
    age: false,
    submitStatus: null,
  }),

  computed: {
    ...mapState(["temp_sns_user"]),

    rule_Errors() {
      const errors = []
      if (!this.$v.rule.$dirty) return errors
      !this.$v.rule.checked && errors.push(this.$t("page.register.warning-check-use-terms"))
      return errors
    },
    privacy_Errors() {
      const errors = []
      if (!this.$v.privacy.$dirty) return errors
      !this.$v.privacy.checked && errors.push(this.$t("page.register.warning-check-privacy-terms"))
      return errors
    },
    age_Errors() {
      const errors = []
      if (!this.$v.age.$dirty) return errors
      !this.$v.age.checked && errors.push(this.$t("page.register.warning-check-age-14"))
      return errors
    },
  },

  methods: {
    // 진행하기
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        markJoinAgreed()
        let path = null
        if (this.temp_sns_user.user_id) {
          path = "/auth/join/snsJoinForm"
        } else {
          path = "/auth/join/form"
        }
        
        this.$router.push({
          path: path,
          query: this.$route.query
        })
      }
    },
  },
}
</script>
<style>
.v-input--checkbox .v-label {
  font-size: 15px;
  font-weight: bold;
}
</style>
